import React from 'react';
import './App.css';

const getRandomColor = () => {
    const colors = ['#FFFFFF', '#FFD700', '#FFFAF0', '#ADD8E6', '#FFA07A', '#D8BFD8'];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const getRandomOpacity = () => {
    return Math.random() * 0.8 + 0.2;
  };

const getRandomValue = (max) => {
  return (Math.random() * max) - (max / 2); // Random value between -max/2 and max/2
};

const StarBackground = React.memo(({starCount = 100, isLoading, className = "", containerStyle = {}}) => {
  const stars = Array.from({ length: starCount }).map((_, index) => {
    const startOpacity = getRandomOpacity();
    const endOpacity = getRandomOpacity();
    return (
    <div
      className={`star ${isLoading ? 'orbit' : ''}`}
      key={index}
      style={{
        top: `${Math.random() * 100}vh`, // Random vertical position
        left: `${Math.random() * 100}vw`, // Random horizontal position
        width: `${Math.random() * 3 + 1}px`, // Random width between 1px and 4px
        height: `${Math.random() * 3 + 1}px`, // Random height between 1px and 4px
        background: getRandomColor(),  // Random background color
        animationDuration: `${Math.random() * 5 + 3}s`, // Random duration between 3s and 8s
        '--random-x': `${getRandomValue(50)}px`, // Random horizontal movement
        '--random-y': `${getRandomValue(50)}px`, // Random vertical movement
        '--start-opacity': startOpacity,
        '--end-opacity': endOpacity,
      }}
    />
  )});

  return <div className={`star-background ${className}`.trim()} style={containerStyle}>{stars}</div>;
});

export default StarBackground;
